<template>
<div>
  <el-card body-style="padding: 0">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">我邀请的收益</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4" :offset="2">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入关键字"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态" prop="tasktype">
            <el-select v-model="queryForm.tasktype" clearable placeholder="请选择任务类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" >
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="headerTableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}">
      <el-table-column label="已结算">
        <el-table-column label="金额" prop="alreadyMoney"></el-table-column>
        <el-table-column label="单数" prop="alreadyOrderNumbers"></el-table-column>
      </el-table-column>
      <el-table-column label="未结算">
        <el-table-column label="金额" prop="unReadyMoney"></el-table-column>
        <el-table-column label="单数" prop="unReadyOrderNumbers"></el-table-column>
      </el-table-column>
    </el-table>

    <el-table :data="tableData" border
              default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}">
      <el-table-column prop="userName" label="用户名" />
      <el-table-column prop="createTime" label="订单编号" />
      <el-table-column prop="shopName" label="店铺" />
      <el-table-column prop="money" label="金额" />
      <el-table-column prop="createTime" label="添加时间" />
      <el-table-column prop="statusStr" label="状态" />
      <el-table-column prop="remarks" label="备注" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryBusinessOrderNum, queryBusinessProfit} from "@/api/b2cbusiness/b2c_saleman";
export default {
  name: "MyRequestStoreFree",
  mixins:[MixinCUD],
  data(){
    return {
      headerTableData:[],
      tableData:[],
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      queryBusinessProfit(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });

      queryBusinessOrderNum().then(res =>{
        if (res.success){
          this.headerTableData = res.data;
        }
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
